// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MaterialsList_wrapper__mpYkS"};